import { render, staticRenderFns } from "./EGiftCardTemplate.vue?vue&type=template&id=35fd4e9e&scoped=true"
import script from "./EGiftCardTemplate.vue?vue&type=script&lang=js"
export * from "./EGiftCardTemplate.vue?vue&type=script&lang=js"
import style0 from "./EGiftCardTemplate.vue?vue&type=style&index=0&id=35fd4e9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fd4e9e",
  null
  
)

export default component.exports